module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_link_image_flow-abc1cde63a23387c78161f2e07b5aa87.jpg";